/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../../app/helpers/restClient';

export const processUpdateSingleOccasionEntry =  (payload) => {
    const {
        ContactId, jwtToken, data, occasionId
    } = payload;
    const wcEnv = {
        rootUri: '/',
    };

    const resourcePage = `addressbook/v2/occasions/${ContactId}/occasion/${occasionId}`;

    return restClient.putFacade(wcEnv, resourcePage, jwtToken, data).then((response) => response);
};

export default processUpdateSingleOccasionEntry;
